import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export type FormInputCheckboxProps = CheckboxProps & {
  name: string;
  label: string;
};

export const FormCheckbox = (props: FormInputCheckboxProps) => {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label={props.label}
      control={<Controller name={props.name} control={control} render={({ field }) => <Checkbox {...field} />} />}
    />
  );
};
